export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7722.6498b190.jpg";